import { createSelector } from 'reselect';

export const getComponentState = state => state.reports;

export const getReportType = createSelector(
    getComponentState,
    (state) => state.reportType
);
export const getPlatform = createSelector(
    getComponentState,
    (state) => state.platform
);
export const getCoupaOrders = createSelector(
    getComponentState,
    (state) => state.coupaOrders
);
export const getPersonalOrders = createSelector(
    getComponentState,
    (state) => state.personalOrders
);
export const getManagerOrders = createSelector(
    getComponentState,
    (state) => state.managerOrders
);
export const getStartDate = createSelector(
    getComponentState,
    (state) => state.startDate
);
export const getEndDate = createSelector(
    getComponentState,
    (state) => state.endDate
);
export const getExporting = createSelector(
    getComponentState,
    (state) => state.exporting
);
